import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { whyChooseUs } from '../../data/mock';

export const WhyChooseUs = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section ref={ref} className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-blue-400 text-sm font-semibold uppercase tracking-widest mb-3 block">
            Why Your IT Solution
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-['Syne'] text-[var(--text-primary)] mb-5">
            Why Choose Us
          </h2>
          <p className="text-[var(--text-muted)] text-lg max-w-2xl mx-auto">
            We combine creativity with strategy to deliver digital solutions that truly move the needle.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {whyChooseUs.map((item, index) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 30 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group p-7 rounded-2xl bg-[var(--card-color)] border border-[var(--border-color)] hover:border-blue-500/20 transition-all duration-500"
              >
                <div className="w-11 h-11 rounded-lg bg-blue-600/10 flex items-center justify-center mb-5 group-hover:bg-blue-600/15 transition-colors duration-500">
                  <Icon className="w-5 h-5 text-blue-400" />
                </div>
                <h3 className="text-lg font-bold font-['Syne'] text-[var(--text-primary)] mb-2">
                  {item.title}
                </h3>
                <p className="text-[var(--text-muted)] text-sm leading-relaxed">
                  {item.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};